import { Component, OnInit, Inject } from '@angular/core';
import { FirebaseService } from '../service/firebase.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-group-creation-modal',
  templateUrl: './group-creation-modal.component.html',
  styleUrls: ['./group-creation-modal.component.scss']
})
export class GroupCreationModalComponent implements OnInit {
  model: any = { name: null };
  constructor(
    public dialogRef: MatDialogRef<GroupCreationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private firebaseService: FirebaseService, private snackBar: MatSnackBar) { }

  ngOnInit() {
  }


  /**
   * Close modal
   * */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * Close modal and return data
   * */
  onCreateGroup() {
    this.dialogRef.close(this.model.name);

  }

}
